let loaded = false;
function loadScript() {
  return new Promise((resolve, reject) => {
    if (loaded || window.Razorpay) { loaded = true; return resolve(); }
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => { loaded = true; resolve(); };
    s.onerror = () => reject(new Error("Could not load payment gateway."));
    document.body.appendChild(s);
  });
}

// Creates an order, runs Razorpay checkout (or demo mode), resolves payment proof.
// Returns the payment proof PLUS the fee breakdown surfaced by the order endpoint
// (fee_original / fee / discount_percent / discount_amount) so the caller can
// show the subscriber savings on the review screen.
export async function pay(api, { description, name, email, consult_type, doctor_id, clinic_id }) {
  const { data: order } = await api.post("/payments/order", {
    purpose: "consultation",
    consult_type: consult_type || "Video consultation",
    doctor_id: doctor_id || "",
    clinic_id: clinic_id || "",
  });
  const breakdown = {
    fee_original: order.fee_original,
    fee: order.fee,
    discount_percent: order.discount_percent,
    discount_amount: order.discount_amount,
  };
  if (order.demo) {
    return { order_id: order.order_id, payment_id: "demo_pay", signature: "demo_sig", demo: true, ...breakdown };
  }
  await loadScript();
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      name: "2nd Opinion Health Consultants",
      description,
      order_id: order.order_id,
      prefill: { name, email },
      theme: { color: "#042C53" },
      handler: (resp) =>
        resolve({
          order_id: order.order_id,
          payment_id: resp.razorpay_payment_id,
          signature: resp.razorpay_signature,
          demo: false,
          ...breakdown,
        }),
      modal: { ondismiss: () => reject(new Error("Payment cancelled.")) },
    });
    rzp.open();
  });
}
